import React from 'react';
import * as S from './styles/VillaDetailsCard.styles';
import HappyBedVillaIcon from '@stencil/icons/src/HappyBedVillaIcon/HappyBedVillaIcon';
import HappyBedsVillaIcon from '@stencil/icons/src/HappyBedsVillaIcon/HappyBedsVillaIcon';
import HappyTwoPeopleOutlined from '@stencil/icons/src/HappyTwoPeopleOutlined/HappyTwoPeopleOutlined';
import HappyVillaIcon from '@stencil/icons/src/HappyVillaIcon/HappyVillaIcon';
import {VillaDataType} from '@stencil/hotels-cg-reducer/src/details/types';

enum AccoType {
  Bedrooms = 'Bedrooms',
  Beds = 'Beds',
  MaxGuests = 'Max Guests',
}

interface VillaDetailsCardProps {
  entirePropertyData: VillaDataType;
}

const VillaDetailsCard: React.FC<VillaDetailsCardProps> = ({entirePropertyData}) => {
  function renderIcon(name: string) {
    switch (name) {
      case AccoType.Bedrooms:
        return <HappyBedVillaIcon width={'15px'} height={'20px'} />;
      case AccoType.Beds:
        return <HappyBedsVillaIcon />;
      default:
        return <HappyTwoPeopleOutlined />;
    }
  }

  const renderComponent = (name: string, text?: string) => {
    if (!text) return null;
    return (
      <S.VillaListItem key={name}>
        <p>{name}</p>
        <S.ItemLogoWrapper>
          {renderIcon(name)}
          <span>{text}</span>
        </S.ItemLogoWrapper>
      </S.VillaListItem>
    );
  };

  return (
    <S.VillaCardWrapper>
      <S.VillaHeaderWrapper>
        <S.VillaIconWrapper>
          <HappyVillaIcon />
        </S.VillaIconWrapper>
        <S.VillaHeader>{entirePropertyData?.title || 'Entire Villa'}</S.VillaHeader>
      </S.VillaHeaderWrapper>
      <S.VillaListWrapper>
        {renderComponent(
          AccoType.Bedrooms,
          !!entirePropertyData?.stayDetail?.bedRoom && `${entirePropertyData?.stayDetail?.bedRoom}`,
        )}
        {renderComponent(
          AccoType.Beds,
          !!entirePropertyData?.stayDetail?.bed && `${entirePropertyData?.stayDetail?.bed}`,
        )}
        {renderComponent(
          AccoType.MaxGuests,
          !!entirePropertyData?.stayDetail?.maxGuests &&
            `${entirePropertyData?.stayDetail?.maxGuests}`,
        )}
      </S.VillaListWrapper>
    </S.VillaCardWrapper>
  );
};

export default VillaDetailsCard;
